import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useServerContext, useOffers, useUserData } from "src/hooks/redux";
import {
  updateShippingInfoError,
  updateShippingInfo,
  updateShippingStatus,
  updatePurchasedPlans,
} from "src/utils/redux/slices/offers";

export const getSingleOffers = (serverContext) => {
  const { offers } = serverContext;
  return offers["hw-offers-baseline"]?.single || [];
};

const getStoreOffers = (serverContext) => {
  const { offers } = serverContext;
  return offers["hw-offers-baseline"]?.store || [];
};

export const useOffersContext = () => {
  const serverContext = useServerContext();
  const userData = useUserData();

  const singleOffers = getSingleOffers(serverContext);
  const offers = getStoreOffers(serverContext);

  const dispatch = useDispatch();

  const setShippingInfo = useCallback(
    (shippingInfo) => {
      dispatch(updateShippingInfo(shippingInfo));
    },
    [dispatch]
  );

  const setShippingInfoError = (shippingInfoError) => {
    dispatch(updateShippingInfoError(shippingInfoError));
  };

  const setShippingStatus = (shippingStatus) => {
    dispatch(updateShippingStatus(shippingStatus));
  };

  const setPurchasedPlans = (purchasedPlans) => {
    dispatch(updatePurchasedPlans(purchasedPlans));
  };

  const { shippingInfo, shippingStatus, shippingInfoError, purchasedPlans } =
    useOffers();

  const name = userData?.name;
  useEffect(() => {
    if (name) {
      const nameSplit = name.split(" ");
      const firstName = nameSplit[0];
      const lastName = nameSplit.slice(1).join(" ");

      setShippingInfo({
        ...shippingInfo,
        firstName,
        lastName,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, setShippingInfo]);

  return {
    offers,
    singleOffers,
    shippingInfo,
    setShippingInfo,
    shippingInfoError,
    setShippingInfoError,
    shippingStatus,
    setShippingStatus,
    setPurchasedPlans,
    purchasedPlans,
  };
};
